import type * as api from "../api";
import { isOldEntry } from "../visits";
import type { Scope } from "./db";
import { visitEntry } from "./local";
import { discard, enqueue, type OutboxEntry } from "./outbox";

export const CONFIRM_OLD = "confirm-old";

/** Keep a visit in the outbox. An old visit goes in only after the confirm, with `old_confirmed` (SO-956). */
export async function keepVisit(
  scope: Scope,
  entry: api.VisitEntry,
  label: string,
  check: { now: Date; hours: number; confirmed: boolean; fixes?: string | null },
): Promise<OutboxEntry | typeof CONFIRM_OLD> {
  const old = isOldEntry(entry.at, check.now, check.hours);
  if (old && !check.confirmed) return CONFIRM_OLD;
  const kept = await enqueue(scope, visitEntry(old ? { ...entry, old_confirmed: true } : entry, label));
  if (check.fixes) await discard(scope, check.fixes);
  return kept;
}
